import { Navigate, useNavigate } from "react-router-dom";
import "./card.css"

export const CardProject = (props) => {
  const {id, title, description, content, link, image_cover, tags} = props.items;

  const navigate = useNavigate()
  const handleDetail = () => {
    navigate(`/project/${title}`, {
        state: {
            id: id, 
            title: title,
            description: description,
            content: content,
            image_cover: image_cover,
            tags: tags,
            link: link
        }
    })
}

console.log("cek tags", tags)

  return (
    <div className="">
      <div className="w-full text rounded-8 card-project mx-auto lg:mx-0 hover:-translate-y-5 duration-300">
        <div className="">
          <img src={image_cover} alt={title} className="w-full h-[360px] lg:h-[220px] object-cover rounded-t-8 cursor-pointer" onClick={handleDetail}></img>
          {/* <img src={image_cover} alt={title} className="h-[220px] w-[358.4px] object-cover rounded-t-8 cursor-pointer" onClick={handleDetail}></img> */}
        </div>
        <div className="pb-1">
          <div className="m-3">
            <p className="m-0 text-14 font-500 cursor-pointer" onClick={handleDetail}>{title}</p>
            <p className="text-9 h-24">{description.substring(0, 80)} . . . </p>
            <div className="flex justify-start gap-2 mb-3 flex-wrap">
              {tags?.map((tag) => 
                <div className="border w-fit py-1 px-2 rounded-md">
                  <p className="text-9 m-0">{tag.tag.name}</p>
                </div>
              )}
            </div>
            <p className="text-right text-9 cursor-pointer" onClick={handleDetail}>See more</p>
          </div>
        </div>
      </div>
    </div>
  )
}